import Vue from 'vue';
import App from './App';
import axios from 'axios';
import './common/rem';
import {
  router
} from './router/index';
import store from './store/index';
import zhCN from '@/common/zh';
import config from '@/common/config';
const VConsole = require('@/common/vconsole');
// import AsyncValidator from 'async-validator'
import './styles/common.less'; // global css
import '@/icons'; // icon
import {
  Badge,
  Calendar,
  Empty,
  Form,
  Tabbar,
  Tag,
  TabbarItem,
  Field,
  RadioGroup,
  Radio,
  Cell,
  Checkbox,
  CheckboxGroup,
  CellGroup,
  Button,
  Icon,
  Popup,
  Uploader,
  NavBar,
  Toast,
  DatetimePicker,
  Dialog,
  Picker,
  Tab,
  Tabs,
  List,
  Loading,
  SwipeCell,
  Switch,
  Stepper,
  Grid,
  GridItem,
  Swipe,
  SwipeItem,
  ImagePreview,
  Overlay,
  Col,
  Row,
  Sidebar,
  SidebarItem,
  Lazyload
} from 'vant';
import VueDragscroll from 'vue-dragscroll';
import 'vant/lib/icon/local.css';
import clipper from './utils/clipper';

axios.get('./config.json').then(e => {
  Vue.prototype.showCompanyName = e.data.showCompanyName;
});

Vue.prototype.zh = zhCN;

Vue.use(VueDragscroll);
Vue.use(clipper);
Vue.use(Badge).use(Calendar).use(Swipe).use(SwipeItem).use(Checkbox).use(CheckboxGroup).use(Empty).use(Tabbar).use(TabbarItem).use(Tag).use(Field).use(RadioGroup).use(Radio).use(Cell).use(CellGroup).use(Button).use(Icon).use(Popup).use(Uploader).use(NavBar).use(Toast).use(DatetimePicker).use(Dialog).use(Picker).use(Tab).use(Tabs).use(List).use(Loading).use(SwipeCell).use(Switch).use(Stepper).use(Grid).use(GridItem).use(ImagePreview).use(Overlay).use(Col).use(Row).use(Form).use(Lazyload).use(Sidebar).use(SidebarItem);
new Vue({
  store,
  router,
  el: '#app',
  render: h => h(App)
});
